import { Partial } from '@40seas/entities/common';
import { UserNotificationSettings } from './user-notification-settings.entity';

export class UpdateUserNotificationSettings extends Partial(UserNotificationSettings) {}
